import { request } from 'services/http/backoffice/instance'

import type { 
  NewsFeedV1SettingsData, 
  NewsFeedV1SettingsResponse,
  NewsFeedV1SettingsRequest 
} from './types'

export const get = () =>
  request<NewsFeedV1SettingsResponse>({
    method: 'get',
    url: 'back-office/news-source/external-news-feed-v1-settings',
  })

export const update = (data: NewsFeedV1SettingsRequest) =>
  request<NewsFeedV1SettingsResponse>({
    method: 'post',
    url: 'back-office/news-source/external-news-feed-v1-settings',
    data,
  })
